import {$axios} from "dot-framework"
import $store from "@/store"
import axios from "axios"

const handleLoading = (showLoading, flag) => {
    if (showLoading) {
        $store.commit('common/setLoading', flag)
    }
}

const self = {
    $get: async (url, params = null, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios
            .get(url, params)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($get) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $post: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)

        return $axios.post(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($post) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $post_noloading: async (url, params, config) => {
        return $axios.post(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($post) ${url}:`, error)
                return null
            })
            .finally(() => {
            })
    },
    $put: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios.put(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($put) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $patch: async (url, params, config, showLoading = false) => {
        handleLoading(showLoading, true)
        
        return $axios.patch(url, params, config)
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.error(`[Error] ($patch) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    $delete: async function (url, params, config, showLoading = false) {
        handleLoading(showLoading, true)
        
        return $axios.delete(url, params, config)
            .then((response) => {
                return response && (response.status === 200 || response.status === 201)
            })
            .catch((error) => {
                console.error(`[Error] ($delete) ${url}:`, error)
                return false
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
    post: async function(url, params, config, showLoading = true) {
        handleLoading(showLoading, true)

        return axios
            .post(url, params, config)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    return response.data
                } else {
                    return response.data.errors
                }
            })
            .catch((error) => {
                console.error(`[Error] (post) ${url}:`, error)
                return null
            })
            .finally(() => {
                handleLoading(showLoading, false)
            })
    },
}

export default self